(function () {
  function initMediaText(section) {
    var trigger = section.querySelector('[data-mt-media-text-open]');
    var modal = section.querySelector('[data-mt-media-text-modal]');
    if (!trigger || !modal) return;

    var closeBtns = modal.querySelectorAll('[data-mt-media-text-close]');
    var dialog = modal.querySelector('.mt-media-text-modal__dialog');
    var scrollBody = modal.querySelector('.mt-media-text-modal__body');

    function openModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (scrollBody) scrollBody.scrollTop = 0;
      if (dialog) dialog.focus();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', openModal);

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal.querySelector('.mt-media-text-modal__overlay')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.mt-media-text[data-section-id]').forEach(initMediaText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.mt-media-text[data-section-id]');
    if (section) initMediaText(section);
  });
})();
